import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { Data2Service } from 'src/app/common/data2.service';

@Component({
	selector: 'app-post-senders',
	templateUrl: './post-senders.component.html',
	styleUrls: ['./post-senders.component.css'],
})
export class PostSendersComponent implements OnChanges {
	yesNoQuestion = '';
	deleteId = '';
	showAdd = false;
	new: PostSender = {
		id: null,
		name: '',
		address: '',
		editable: false,
	};

	@Input() senders: Array<PostSender> = [];
	@Output() sendersChange = new EventEmitter();
	@Output() changed = new EventEmitter();
	questionSubscription;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
	) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.senders && changes.senders.currentValue) {
			this.senders.forEach((obj) => {
				obj.editable = false;
			});
		}
	}

	edit(sender) {
		sender.editable = true;
	}

	delAsk(sender) {
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'deleteAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.api.del('/postSenders/' + sender.id, (result, error) => {
				if (error) {
					return;
				}
				this.sendersChange.emit(this.senders.filter((obj) => obj.id != sender.id));
				this.changed.emit(sender.id);
			});
		});
	}

	add() {
		this.api.post('/postSenders/', this.new, (result, error) => {
			if (error) {
				return;
			}
			// push not working with ng-select
			this.senders = [
				...this.senders,
				{
					id: result.data,
					name: this.new.name,
					address: this.new.address,
					editable: false,
				},
			];
			this.new.name = '';
			this.new.address = '';
			this.showAdd = false;
			this.sendersChange.emit(this.api.sortAlphabetically(this.senders, 'name'));
			this.changed.emit(result.data);
		});
	}

	submit(sender: PostSender) {
		sender.editable = false;
		this.api.put('/postSenders/' + sender.id, sender, (result, error) => {
			if (error) {
				return;
			}
			this.changed.emit(sender.id);
		});
	}
}

export interface PostSender {
	id: string;
	name: string;
	address: string;
	editable: boolean;
}
